export default function Marquee({
  items = [
    "AI Certified",
    "Black Women Built",
    "Powered by Prompts",
    "School at Night",
    "Secure the Bag",
  ],
  variant = "yellow",
}) {
  const bg = variant === "yellow" ? "bg-[#FFD60A] text-black" : "bg-black text-[#FFD60A]";
  const border = variant === "yellow" ? "border-y-2 border-black" : "border-y-2 border-[#FFD60A]";
  // Duplicate items for seamless loop
  const list = [...items, ...items];
  return (
    <div
      className={`${bg} ${border} overflow-hidden relative`}
      data-testid="marquee"
    >
      <div className="marquee-track py-4 md:py-5">
        {list.map((t, i) => (
          <span
            key={i}
            className="font-display uppercase text-2xl md:text-3xl tracking-tight px-8 inline-flex items-center"
          >
            {t}
            <span className="ml-8 inline-block h-2 w-2 rounded-full bg-current opacity-70" />
          </span>
        ))}
      </div>
    </div>
  );
}
